import { createIcon } from "@chakra-ui/react";
import * as React from "react";

const UserCheck = createIcon({
  path: (
    <path
      d="M6.87909 7.27475C5.12255 7.27475 3.61111 5.67297 3.61111 3.604C3.61111 1.56007 5.13072 0 6.87909 0C8.62745 0 10.1471 1.5267 10.1471 3.58732C10.1471 5.67297 8.62745 7.27475 6.87909 7.27475ZM15.4085 7.76696C15.1389 7.76696 14.9265 7.65017 14.7141 7.3832L12.7206 4.88042C12.6062 4.72191 12.5327 4.53838 12.5327 4.36318C12.5327 3.98776 12.8105 3.69577 13.1699 3.69577C13.3905 3.69577 13.5784 3.77086 13.7663 4.03782L15.3758 6.15684L18.7745 0.60901C18.9216 0.358732 19.1258 0.233593 19.3382 0.233593C19.6732 0.233593 20 0.475528 20 0.842603C20 1.02614 19.902 1.21802 19.8039 1.37653L16.0703 7.3832C15.9069 7.63348 15.6863 7.76696 15.4085 7.76696ZM1.39706 15C0.522876 15 0 14.5829 0 13.8904C0 11.738 2.63889 8.76808 6.87092 8.76808C11.1111 8.76808 13.75 11.738 13.75 13.8904C13.75 14.5829 13.2271 15 12.3529 15H1.39706Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 20 15",
});

export { UserCheck };
